/*
  STL FACETS — MINKPINK (Edge 2.0.0), 22 Sep 2026. Loaded by sections/stl-site-assets.liquid.

  1. DEFERRED APPLY. Edge submits the drawer form on every tick (facets.js: `input` ->
     500ms debounce -> onSubmitHandler). We wrap FacetFiltersForm.prototype.onSubmitHandler
     and HOLD anything coming from the drawer form (#FacetFiltersFormMobile) until the
     drawer's Apply button is pressed. Wrapping the prototype (rather than listening for
     `input`) catches every route in — checkboxes, the price inputs and the noUiSlider,
     which dispatches its own `input` on the form — and survives Edge re-rendering the
     drawer. The desktop "SORT BY +" select lives in a different form and still applies
     immediately.
  2. IN STOCK RIDES ALONG WITH SIZE. On Apply, if any size is ticked the availability
     filter is set to "In stock"; if none is, it is cleared. Shopify intersects
     filter.v.* at the VARIANT level, so size + in-stock means "in stock IN THAT SIZE".
     Needs the Availability filter enabled in Search & Discovery; its group is hidden (stl.css).
  3. SORT is trimmed to live's four options, in live's order and wording.
  4. Drawer title reads "Refine", as on live.

  If Edge renames FacetFiltersForm or onSubmitHandler, the wrap never installs and the
  drawer falls back to Edge's own behaviour (filters apply as they are ticked).
*/
(function () {
  'use strict';

  var FORM_ID = 'FacetFiltersFormMobile';
  var SIZE_PARAM = 'filter.v.option.size';
  var STOCK_PARAM = 'filter.v.availability';
  var SORTS = [
    ['created-descending', 'New Arrivals'],
    ['best-selling', 'Best Selling'],
    ['price-descending', 'Price: High to Low'],
    ['price-ascending', 'Price: Low to High']
  ];
  var applying = false;

  function formOf(event) {
    var t = event && event.target;
    if (!t) return null;
    if (t.tagName === 'FORM') return t;
    return t.closest ? t.closest('form') : null;
  }

  customElements.whenDefined('facet-filters-form').then(function () {
    var ctor = customElements.get('facet-filters-form');
    var proto = ctor && ctor.prototype;
    if (!proto || typeof proto.onSubmitHandler !== 'function' || proto.stlWrapped) return;
    var original = proto.onSubmitHandler;
    proto.onSubmitHandler = function (event) {
      var form = formOf(event);
      if (form && form.id === FORM_ID && !applying) {
        if (event && event.preventDefault) event.preventDefault();
        return; // held until Apply
      }
      return original.call(this, event);
    };
    proto.stlWrapped = true;
  });

  // In stock rides along with a ticked size.
  function syncStock(form) {
    var sizeTicked = !!form.querySelector('input[name="' + SIZE_PARAM + '"]:checked');
    var boxes = form.querySelectorAll('input[name="' + STOCK_PARAM + '"]');
    var hidden = form.querySelector('input[data-stl-stock]');
    if (boxes.length) {
      // Two checkboxes share the name: In stock (1) and Out of stock (0). Set by VALUE —
      // ticking both means "either", i.e. no filter at all.
      boxes.forEach(function (b) { b.checked = sizeTicked && b.value === '1'; });
      if (hidden) hidden.remove();
    } else if (sizeTicked && !hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = STOCK_PARAM;
      hidden.value = '1';
      hidden.setAttribute('data-stl-stock', '');
      form.appendChild(hidden);
    } else if (!sizeTicked && hidden) {
      hidden.remove();
    }
  }

  function apply(button) {
    var form = document.getElementById(FORM_ID);
    var host = form && form.closest('facet-filters-form');
    if (!form || !host || typeof host.onSubmitHandler !== 'function') return false;
    syncStock(form);
    applying = true;
    try {
      // Edge's own submit path. The className makes it submit the drawer form alone.
      host.onSubmitHandler({
        preventDefault: function () {},
        target: form,
        srcElement: { className: 'mobile-facets__checkbox' }
      });
    } finally {
      applying = false;
    }
    var drawer = button.closest('component-drawer');
    var close = drawer && drawer.querySelector('.close-drawer-btn');
    if (close) close.click();
    return true;
  }

  // Edge's Apply only closes the drawer (inline onclick). Capture-phase so we run first
  // and can stop that onclick; if apply() cannot run, Edge's close still happens.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#drawer-filter .mobile-facets__footer .btn-primary');
    if (!btn) return;
    if (apply(btn)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Sort + title. Re-run whenever Edge re-renders.
  function tidy() {
    document.querySelectorAll('select[name="sort_by"]:not([data-stl-sort])').forEach(function (select) {
      var current = select.value;
      var byValue = {};
      Array.prototype.forEach.call(select.options, function (o) { byValue[o.value] = o; });
      var keep = [];
      SORTS.forEach(function (s) {
        var o = byValue[s[0]];
        if (o) { o.textContent = s[1]; keep.push(o); }
      });
      if (!keep.length) return; // unexpected markup — leave Edge's list alone
      // Keep the active sort selectable-but-hidden if it is not one of the four
      // (e.g. a collection's default "Featured"), so the control still reflects state.
      var active = byValue[current];
      Array.prototype.slice.call(select.options).forEach(function (o) { select.removeChild(o); });
      keep.forEach(function (o) { select.appendChild(o); });
      if (active && keep.indexOf(active) === -1) {
        active.hidden = true;
        select.insertBefore(active, select.firstChild);
      }
      select.value = current;
      select.setAttribute('data-stl-sort', '');
    });
    var title = document.querySelector('#drawer-filter .drawer-header h4');
    if (title && title.textContent.trim() !== 'Refine') title.textContent = 'Refine';
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; tidy(); }, 0);
  }
  function start() {
    tidy();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
